import React from 'react'

const Info = () => {
  return (
    <svg width='25' height='26' viewBox='0 0 25 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <line
        x1='1.41421'
        y1='1'
        x2='24'
        y2='23.5858'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M10.4926 18.6121C10.3836 18.6121 10.2773 18.5695 10.1977 18.4906L7.98713 16.2945C7.87737 16.1855 7.83681 16.0247 7.88186 15.8766C8.41695 14.1121 9.11058 12.3515 9.94408 10.6436C10.7766 8.92984 11.8137 6.79588 13.2132 5.30734C13.2137 5.30684 13.2139 5.30634 13.2147 5.30584C16.3553 1.99847 21.3929 1.85384 24.1154 2.06167C24.3222 2.0776 24.4863 2.24261 24.5007 2.44943C24.6911 5.17146 24.5218 10.2002 21.2516 13.2954C19.7814 14.6911 17.6161 15.72 15.8762 16.5468C14.1595 17.3738 12.3874 18.0632 10.6121 18.5946C10.5728 18.606 10.5322 18.6118 10.4924 18.6118L10.4926 18.6121ZM8.7559 15.8793L10.6098 17.7215C12.2637 17.2131 13.9128 16.5648 15.5153 15.7927C17.2915 14.949 19.3023 13.9933 20.6763 12.6889C23.5608 9.95918 23.8277 5.50904 23.689 2.8713C21.0504 2.71699 16.5926 2.96388 13.8217 5.88151C12.5098 7.27748 11.5041 9.34721 10.696 11.0102C9.91943 12.6011 9.26739 14.2377 8.7557 15.8796L8.7559 15.8793Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M17.1394 11.4692C16.6008 11.4692 16.063 11.2656 15.6531 10.8587C15.2554 10.4638 15.0361 9.93787 15.0361 9.3784C15.0361 8.81893 15.2551 8.29329 15.6534 7.89808C16.4724 7.08375 17.8059 7.08445 18.6253 7.89808C19.023 8.2933 19.2423 8.81893 19.2423 9.3784C19.2423 9.93787 19.0232 10.4635 18.6253 10.8587C18.2161 11.2659 17.6777 11.4692 17.1394 11.4692ZM17.1394 8.12299C16.8146 8.12299 16.4899 8.24594 16.2427 8.49158C16.0038 8.72877 15.8726 9.04385 15.8726 9.37886C15.8726 9.71385 16.004 10.0289 16.2425 10.2659C16.7372 10.7574 17.5414 10.7574 18.0359 10.2659C18.2746 10.0287 18.406 9.71361 18.406 9.3786C18.406 9.04361 18.2743 8.72853 18.0359 8.49133C17.789 8.24568 17.4642 8.12299 17.1394 8.12299Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M9.08027 13.8157C9.06907 13.8157 9.05763 13.8154 9.04643 13.8142L5.359 13.52C5.23207 13.51 5.11708 13.4428 5.04565 13.3373C4.97447 13.232 4.95531 13.0999 4.99314 12.9787C5.11659 12.583 6.36623 9.04582 12.0902 6.73996C12.2495 6.67625 12.4327 6.71582 12.5509 6.84151C12.6691 6.96695 12.6977 7.15211 12.6238 7.30766C12.573 7.41394 12.4834 7.48935 12.3794 7.52519C8.0658 9.26884 6.49711 11.6783 5.99339 12.7318L9.11287 12.9807C9.34309 12.9991 9.51481 13.2007 9.4964 13.4307C9.47947 13.6497 9.29655 13.8157 9.08052 13.8157L9.08027 13.8157Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M13.4253 21.5033C13.3424 21.5033 13.2608 21.4787 13.1909 21.4314C13.0859 21.3602 13.0189 21.2455 13.0087 21.1188L12.7128 17.456C12.6944 17.2258 12.8658 17.0242 13.0958 17.0056C13.3238 16.9867 13.5279 17.1584 13.5463 17.3888L13.7967 20.4872C14.8537 19.9892 17.28 18.4341 19.0369 14.1554C19.0685 14.0494 19.1419 13.956 19.2491 13.9025C19.4044 13.8249 19.5943 13.8505 19.722 13.969C19.8499 14.0874 19.8925 14.2714 19.8268 14.4329C17.5065 20.1193 13.9467 21.3617 13.5488 21.4847C13.5082 21.4971 13.4666 21.5033 13.4253 21.5033Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M23.4894 9.15835C23.3829 9.15835 23.2761 9.11803 23.1945 9.0369L17.4886 3.36811C17.3251 3.20534 17.3238 2.94053 17.4866 2.77677C17.6496 2.61325 17.9139 2.61176 18.0782 2.77478L23.7841 8.44357C23.9476 8.60634 23.9488 8.87115 23.7861 9.03491C23.7039 9.11704 23.5969 9.15835 23.4894 9.15835Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M2.63925 24.7801C2.53472 24.7801 2.42994 24.7411 2.3488 24.6627C2.18255 24.5021 2.17832 24.2376 2.3386 24.0713L7.37943 18.8525C7.53996 18.6868 7.80452 18.682 7.97077 18.8423C8.13703 19.0029 8.14126 19.2674 7.98098 19.4337L2.94014 24.6527C2.85776 24.7373 2.74876 24.7801 2.63925 24.7801Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M6.18623 25.0001C6.08768 25.0001 5.98837 24.9652 5.90898 24.8948C5.73651 24.7415 5.72058 24.4769 5.87413 24.3045L9.14092 20.6272C9.29398 20.4548 9.55855 20.4388 9.73102 20.5924C9.90349 20.746 9.91942 21.0103 9.76586 21.1827L6.49907 24.8597C6.41644 24.9528 6.30172 25.0001 6.18623 25.0001Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M2.41768 21.476C2.31912 21.476 2.21982 21.4412 2.14042 21.3705C1.96795 21.2172 1.95202 20.9529 2.10558 20.7804L5.37262 17.1032C5.52568 16.9307 5.79025 16.9145 5.96272 17.0683C6.13519 17.2216 6.15112 17.4859 5.99757 17.6584L2.73027 21.3357C2.64788 21.4287 2.53291 21.476 2.41768 21.476Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
    </svg>
  )
}

export default Info
